import React from 'react';
import OrdersList from '../components/orders/OrdersList';

const Orders: React.FC = () => {
  return <OrdersList />;
};

export default Orders;